import { useEffect, useState } from "react";
import { country } from "./CountryCode";
import { Dropdown } from "primereact/dropdown";

import ReactCountryFlag from "react-country-flag"





export default function CountryCodeComponet({ options, onChange, name, value }) {
    const getFlag = (name) => {
      
        
        var extend_codes = {
            "+1-242": "BS",
            "+1-246": "BB",
            "+1-268": "AG",
            "+1-284": "VG",
            "+1-441": "BM",
            "+1-473": "GD",
            "+1-664": "MS",
            "+1-758": "LC",
            "+1-767": "DM",
            "+1-784": "VC",
            "+1-868": "TT",
            "+1-869": "KN",
            "+1-876": "JM",
            "+383": "XK"
        }
        var getCode = Object.entries(country).reduce((acc, [key, value]) => {
            acc[`+${value}`] = key;  // Swap the key-value pair
            return acc;
        }, {});
        getCode = { ...getCode,  ...extend_codes }
    
        var place = "za"
        if (name in getCode) {
            place = getCode[name]
            // console.log(name)
        }
        return (
            <div style={{ display: "flex" ,alignItems:"center"}} className="flex align-items-center">
                 <ReactCountryFlag
                countryCode={place}
                svg
                style={{
                    width: '1.4em',
                }}
                title={place}
            />
                <div>{name}</div>
            </div>
        );
    };
    

    var [count, setCount] = useState([])
    useEffect(() => {
        options = options?.map(e => {
            e.tag = getFlag(e.name)
            return e;
        })
        options?.reverse()
        setCount(options)
    }, [options])


    return (<>
        <Dropdown
            autocomplete="off"
            filterBy="name,description"
            filter={"name"}
            value={value}
            name={name}
            options={count}
            onChange={onChange}
            optionLabel="tag"
            optionValue="id"

            style={{ width: "150px" }}
            className="p-mr-2"
            autoComplete="off"
        />
    </>)

}